import { render, staticRenderFns } from "./GuideArticle.vue?vue&type=template&id=ba8e3d3a&scoped=true&"
import script from "./GuideArticle.vue?vue&type=script&lang=js&"
export * from "./GuideArticle.vue?vue&type=script&lang=js&"
import style0 from "./GuideArticle.vue?vue&type=style&index=0&id=ba8e3d3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8e3d3a",
  null
  
)

export default component.exports